A page of advertisement brandings associated with the specified `hirerId`.

A maximum of 100 advertisement brandings can be returned in a single page.
Additional advertisement brandings can be queried using a pagination cursor.

The result list is returned in ascending creation date & time order.
It starts from the earliest known advertisement branding if no pagination arguments are provided.

This query accepts browser tokens that include the `query:advertisement-brandings` or `query:enhanced-job-posting` scope.
